import { uniqBy } from 'lodash';

export const mergeEntities = <T extends { id: number | string }>(
  a: T[],
  b: T[]
): T[] => {
  return uniqBy([...a, ...b], 'id') as T[];
};
